import { Autocomplete, Box, TextField } from '@mui/material';

const optionLabel = (key) => {
  if (!key) return '';
  return key.charAt(0).toUpperCase() + key.slice(1);
};

export default function LuxuryProOptionPicker({ optionKey, values, value, onChange, disabled }) {
  const selected = value || null;
  const label = optionLabel(optionKey);

  return (
    <Autocomplete
      disabled={disabled}
      size="small"
      sx={{ minWidth: 160, flex: '1 1 160px' }}
      options={values || []}
      value={selected}
      onChange={(_, v) => onChange(v || '')}
      getOptionLabel={(v) => v || ''}
      isOptionEqualToValue={(a, b) => a === b}
      noOptionsText="Không có giá trị"
      renderOption={(props, option) => (
        <Box
          component="li"
          {...props}
          sx={{ fontSize: 13, lineHeight: 1.35, py: 1, px: 1.5 }}
        >
          {option}
        </Box>
      )}
      renderInput={(params) => (
        <TextField
          {...params}
          label={label}
          placeholder={`Chọn ${label}`}
        />
      )}
    />
  );
}
